import React from 'react';

// Shows a friendly screen instead of a blank page if something crashes — most often after a new
// deploy, when an open tab tries to load page code that no longer exists (fixed by reloading).
class ErrorBoundary extends React.Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('App crashed:', error, info);
    }

    render() {
        if (!this.state.hasError) return this.props.children;
        return (
            <div className="flex min-h-screen flex-col items-center justify-center bg-pink-50 px-4 text-center">
                <img src="/logoinsafbakery.png" alt="Insaf Bakery" width="80" height="80" className="mb-4 h-20 w-20" />
                <h1 className="text-xl font-bold text-gray-800">Something went wrong</h1>
                <p className="mt-2 text-gray-600">Please reload the page.</p>
                <button onClick={() => window.location.reload()} className="btn-primary mt-6">Reload</button>
            </div>
        );
    }
}

export default ErrorBoundary;
